import { TYP_CONFIG } from '../constants'

const getFontSizeByStep = (step: number, typ_config: any = TYP_CONFIG) => {
  return Math.round(parseInt(typ_config.baseFontSize, 10) * Math.pow(typ_config.scaleFactor, step))
}

const getLineHeightByFontSize = (numFontSize: number, typ_config: any = TYP_CONFIG) => {
  const numLineHeight = parseInt(typ_config.baseLineHeight)
  return numLineHeight * Math.ceil(numFontSize / numLineHeight)
}

export const calcFontScale = (step: number, typ_config: any = TYP_CONFIG) => {
  const numFontSize = getFontSizeByStep(step, typ_config)
  return `font-size: ${numFontSize}px; line-height: ${getLineHeightByFontSize(
    numFontSize,
    typ_config
  )}px`
}



// WEBPACK FOOTER //
// ./src/styles/calcFontScale/index.ts